import BlogPost from 'components/blog/blog-post/blog-post';
import Container from 'components/container/container';
import Link from 'next/link';
import { LIBUM_URL } from 'shared/constants/globals';
import { BLOG_ITEMS } from 'shared/data/blogs';

const BLOG = BLOG_ITEMS.find((b) => b.id === 'we-have-a-blog')!;

export default function WeHaveABlog() {
  const title = `${BLOG.title} | Libum`;
  const description = BLOG.description;
  const keywords = BLOG.keywords.join(',');
  const url = `${LIBUM_URL}/blog/${BLOG.id}`;

  return (
    <Container title={title} description={description} keywords={keywords} url={url} socialCard="blog">
      <div style={{ width: '100%' }}>
        <BlogPost blog={BLOG}>
          <p>
            We do now! As a matter of fact, this has been one of our intentions since the website revamp from early this
            year - our goal is to create a sense of transparency between the Libum team and every credit union that
            might be interested in what it is we do.
          </p>
          <div className="divider" />
          <h2 className="anchor" id="how-we-got-our-name">
            <Link href="#how-we-got-our-name">How We Got Our Name</Link>
          </h2>
          <p>
            To kick things off, how about a quick back story for how we came up with the name <i>Libum</i>. As much as
            we enjoy hearing stories of credit unions sharing their experience when they first attempt to Google search
            our company, it&apos;s <b>NOT</b> because we&apos;re secretly a Roman Cheesecake company. It&apos;s actually
            because when Don and I were early on in our software development career at a credit union in Southeast
            Houston and were asked whether or not a custom solution was possible, we almost always replied with &quot;oh
            yeah for sure, that&apos;s a piece of cake&quot;.
          </p>
          <p>
            Fast forward to the moment we&apos;re on a Google Meet tossing around different company name ideas and after
            about the 15th English word we tried translating to Latin, &quot;cake&quot; ahem, I mean <i>Libum</i>, made
            the cut.
          </p>
          <div className="divider" />
          <h2 className="anchor" id="company-vision">
            <Link href="#company-vision">Company Vision</Link>
          </h2>
          <p>
            At Libum, we&apos;re working tirelessly to design and develop groundbreaking products which will
            dramatically augment the traditional UX of credit union employees of every department. Innovation of course
            takes time, but we truly believe that with a team like ours, we&apos;ll be able to deliver on this vision
            and set new standards for the industry.
          </p>
          <figure>
            <img
              src="/images/97ce019c-2584-42a9-b1a6-1ab0a437a883.jpg"
              alt="Libum team members at Jack Henry Connect in 2022"
            />
          </figure>
          <p>
            <Link href="/glaci">Glaci</Link> will fundamentally rock people&apos;s socks off when it&apos;s complete and
            we are closer than ever to having it available for our early adopters. And,{' '}
            <Link href="/nexum">NexumAPI</Link> (which will be available at this year&apos;s{' '}
            <a href="https://www.cubuild.org/">CU Build</a> - quick plug, if you haven&apos;t signed up yet) is already
            saving so many hours of internal development hours for our team, we just had to share.
          </p>
          <div className="divider" />
          <p>
            I imagine the next few blogs will begin to dive into our feature set so you all can get a taste of
            what&apos;s coming from the Libum team so, stay tuned!
          </p>
        </BlogPost>
      </div>
    </Container>
  );
}
